import React from 'react';

const LOGO_SRC =
  'https://customer-assets.emergentagent.com/job_leamington-gutters/artifacts/ohfemg9o_Copy%20of%20Pink%20Typography%20Initial%20LP%20Logo.png';

// Brand logo — supplied by Leamington Gutters
export const Logo = ({ height = 56, className = '' }) => (
  <img
    src={LOGO_SRC}
    alt="Leamington Gutters"
    className={`logo-mark block w-auto ${className}`}
    style={{ height: `${height}px` }}
    loading="eager"
    decoding="async"
  />
);

// Backwards-compatible cropped image helper (used by Gallery to crop the flyer)
export const CroppedImage = ({ crop, alt, src, className = '', style = {} }) => {
  const cropW = (crop.right - crop.left) / 100;
  const cropH = (crop.bottom - crop.top) / 100;
  return (
    <div className={`relative overflow-hidden ${className}`} style={style}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        style={{
          position: 'absolute',
          width: `${100 / cropW}%`,
          height: `${100 / cropH}%`,
          left: `${-crop.left / cropW}%`,
          top: `${-crop.top / cropH}%`,
          maxWidth: 'none',
          objectFit: 'cover',
        }}
      />
    </div>
  );
};

export default Logo;
